<template>
  <div>
    <top-header :type="15" :placeholder="this.keyWord" textColor="#000" bgColor="#fff" fontSize="0.32rem"
      @goBack="goback" />
    <div class="title">
      <img :src="kefuPath + obj.detailPic" alt="">
    </div>
    <div class="c_contain_tit">
      业务分类简介
    </div>
    <div class="dec">
      {{ obj.briefIntroduction }}
    </div>
    <div class="c_contain_tit">
      合作方
    </div>
    <div class="list">
      <div class="row m_flex_box flex_vc flex_jz" v-for="item in obj.partnerList" :key="item.id" @click="jump(item)">
        <div class="left m_flex_box flex_vc">
          <img :src="kefuPath + item.logo" alt="" class="img" />
          <div>
            <div class="h3">{{ item.name }}</div>
          </div>
        </div>
        <img src="@/assets/img/right.png" class="arrow_all" />
      </div>
    </div>
  </div>
</template>
<script>
import topHeader from "@/components/header";
export default {
  data() {
    return {
      isApp: this.$route.query.isApp || false,
      keyWord: this.$route.query.keyWord || "",
      kefuPath: this.kefuPath,
      id: this.$route.query.id || "1595773349174018050",
      obj: {}
    };
  },
  created() {

  },
  components: {
    topHeader,
  },
  mounted() {
    this.init()
  },
  methods: {
    goback() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    jump(n) {
      this.$router.push({
        path: "/bankLoans",
        query: {
          id: n.id,
          keyWord: this.keyWord
        }
      });
    },
    init() {
      this.$request_xf.get("service/api/queryLaborClassificationDetail?id=" + this.id).then((res) => {
        this.obj = res.result;
      }).catch(res => {
        this.$msg(res.msg);
      });
    }
  }
}
</script>

<style lang="less">
.title {
  img {
    width: 100%;
  }
}

.c_contain_tit {
  margin: 0.4rem 0.3rem;
  display: flex;
  font-size: 16px;
  align-items: center;

  &:before {
    content: '';
    width: 3px;
    height: 0.4rem;
    background-color: #376bff;
    margin-right: 10px;
  }
}

.dec {
  font-size: 15px;
  padding: 5px 0.3rem;
  text-indent: 20px;
  background: #fff;
}

.list {
  padding: 0 0.5rem;
  background: #fff;

  .row {
    width: 100%;
    padding: 0.3rem 0;
    border-bottom: 1px solid #f5f5f5;

    .arrow_all {
      width: 0.4rem;
      height: 0.4rem;
    }

    .img {
      width: 0.5rem;
      height: 0.5rem;
      margin-right: 0.3rem;
    }

    .left {
      .h3 {
        font-size: 18px;
        color: #101010;
        // font-weight: 800;
      }

      .p {
        font-size: 24px;
        color: #A0A0A0;
      }
    }

    .i {
      font-size: 26px;
      color: #A0A0A0;
    }
  }
}
</style>